import { createFileRoute, redirect } from '@tanstack/react-router'

import { abscencesFilterSchema } from '@/modules/absences'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { isFeatureFlagEnabled } from '@/utils/is-feature-flag-enabled'

export const Route = createFileRoute('/_auth/absences/')({
  validateSearch: abscencesFilterSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context }) => {
    const enabledAbsences2 = isFeatureFlagEnabled(
      'IS_ABSENCES_2_0_MODULE_ENABLED'
    )

    const semesters = await context.queryClient.ensureQueryData(
      semesterQueryOptions({})
    )

    if (enabledAbsences2) {
      throw redirect({
        to: '/absences/all',
        replace: true,
        search: { ...search, semester: semesters.currentSemester?.id }
      })
    } else if (!search.semester) {
      throw redirect({
        to: '/absences',
        replace: true,
        search: { ...search, semester: semesters.currentSemester?.id }
      })
    }
  }
})
